export class DialogModelPastSI{
    constructor(
      public data:any
    ) {}
  }